import React, { useState, useEffect } from "react";
import { X, Calendar, Clock, Building } from "lucide-react";
import { getVehicleHistory } from "../../api/vehicalsManagementApi";

const VehicleHistoryModal = ({ isOpen, onClose, vehicle }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen && vehicle?.id) {
      fetchHistory();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, vehicle]);

  const fetchHistory = async () => {
    try {
      setLoading(true);
      const response = await getVehicleHistory(vehicle.id);
      if (response.success) {
        setHistory(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching vehicle history", error);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 2000,
        }}
      />
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
          backgroundColor: "white",
          zIndex: 2001,
          width: "90%",
          maxWidth: "600px",
          boxShadow: "0 24px 48px rgba(0,0,0,0.2)",
          borderRadius: "12px",
          maxHeight: "80vh",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <div
          style={{
            backgroundColor: "#227B48",
            padding: "16px 24px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <h2 style={{ margin: 0, fontSize: "18px", fontWeight: 700, color: "white" }}>
              Vehicle Assignment History
            </h2>
            <p style={{ margin: "4px 0 0", fontSize: "12px", color: "#E8F5EE" }}>
              {vehicle?.vehicleNumber || vehicle?.registrationNumber}
            </p>
          </div>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "white",
              display: "flex",
              alignItems: "center",
            }}
          >
            <X size={20} />
          </button>
        </div>

        {/* Content */}
        <div style={{ padding: "24px", overflowY: "auto", flex: 1 }}>
          {loading ? (
            <div style={{ textAlign: "center", padding: "40px", color: "#666" }}>
              Loading history...
            </div>
          ) : history.length === 0 ? (
            <div style={{ textAlign: "center", padding: "40px", color: "#888" }}>
              No history found for this vehicle.
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                position: "relative",
                paddingLeft: "20px",
                borderLeft: "2px solid #E5E7EB",
                marginLeft: "8px",
              }}
            >
              {history.map((item, index) => (
                <div key={item.id || index} style={{ position: "relative" }}>
                  {/* Timeline bullet indicator */}
                  <div
                    style={{
                      position: "absolute",
                      left: "-27px",
                      top: "4px",
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                      backgroundColor: item.status === "Assigned" ? "#227B48" : "#EF4444",
                      border: "2px solid white",
                      boxShadow: "0 0 0 2px #E5E7EB",
                    }}
                  />
                  <div
                    style={{
                      backgroundColor: "#F9FAFB",
                      borderRadius: "8px",
                      padding: "16px",
                      border: "1px solid #F3F4F6",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "start",
                        marginBottom: "8px",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <Building size={16} color="#4B5563" />
                        <span style={{ fontWeight: 600, color: "#1F2937", fontSize: "14px" }}>
                          {item.client?.clientName || "Unknown Client"}
                        </span>
                      </div>
                      <span
                        style={{
                          fontSize: "11px",
                          fontWeight: 600,
                          padding: "2px 8px",
                          borderRadius: "12px",
                          backgroundColor: item.status === "Assigned" ? "#E8F5EE" : "#FEE2E2",
                          color: item.status === "Assigned" ? "#227B48" : "#EF4444",
                        }}
                      >
                        {item.status}
                      </span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "4px",
                        fontSize: "12px",
                        color: "#6B7280",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <Calendar size={14} />
                        <span>
                          <strong>Assigned:</strong>{" "}
                          {new Date(item.assignedDate).toLocaleDateString("en-IN", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })}
                        </span>
                      </div>
                      {item.releasedDate && (
                        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                          <Clock size={14} />
                          <span>
                            <strong>Released:</strong>{" "}
                            {new Date(item.releasedDate).toLocaleDateString("en-IN", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            })}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default VehicleHistoryModal;
